export const getCurrentSeasonStartYear = () => {
    const today = new Date();
    return today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
};

export const getSeasonDateRange = (startYear) => ({
    startDate: `${startYear}-04-01`,
    endDate: `${startYear + 1}-03-31`,
});

export const getCurrentSeasonDateRange = () => getSeasonDateRange(getCurrentSeasonStartYear());

/**
 * Devuelve la temporada (año de inicio) a la que pertenece un rango de fechas
 * si coincide exactamente con una temporada cinegética, o null si es un rango
 * personalizado.
 */
export const matchSeasonFromRange = (startDate, endDate) => {
    if (!startDate || !endDate) return null;
    const start = String(startDate);
    const end = String(endDate);
    const startMatch = start.match(/^(\d{4})-04-01/);
    const endMatch = end.match(/^(\d{4})-03-31/);
    if (!startMatch || !endMatch) return null;
    const startYear = parseInt(startMatch[1], 10);
    const endYear = parseInt(endMatch[1], 10);
    return endYear === startYear + 1 ? startYear : null;
};
